import { supabaseFreeTable } from "../utils/supabase/clientFreeTable";
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';

export const useUser = (id) => {
    return useQuery({
      queryKey: ['users', id], 
      queryFn: async()=>{
        const {data, error} = await supabaseFreeTable.from('profiles').select('*').eq('id', id).single(); 
        if (error){
          console.log(error); 
          throw new Error(error.message); 
          
        }
        return data; 
  
  
      }
    });
    
  }



    export const useUpdateNoShow  = ()=>{
    const queryClient = useQueryClient();
    return useMutation({
      async mutationFn({userid,reservationsleft}){ 
        const { data, error } = await supabaseFreeTable
          .from('profiles')
          .update({ no_shows_left:reservationsleft })
          .eq('id', userid)
          .select();
   
        if (error){
          console.log(error?.message)
          throw new Error(error.message); 
          
        }

      },
      async onSuccess(_,{userid}){
        queryClient.invalidateQueries(['users',userid]); 
        
      }
    })
  }
